export const declarationActiviteKeys = {
  all: ["declaration-activite"] as const,
  admin: (siren: string, millesime: number, categorie: string) =>
    [
      ...declarationActiviteKeys.all,
      "admin",
      siren,
      millesime,
      categorie,
    ] as const,
};
